import React from 'react';
import { UserEntity } from '@interpals/api-web';

import EmptyAvatarMale from 'assets/sprite-colored-icons/avatar-male.svg';
import EmptyAvatarFemale from 'assets/sprite-colored-icons/avatar-female.svg';
import DeletedUserAvatar from 'assets/images/deleted-user-avatar.svg';
import Thumbnail, { ThumbnailProps, ThumbSize } from 'components/Thumbnail/Thumbnail';

export interface UserAvatarProps extends Omit<ThumbnailProps, 'size'> {
    user?: Pick<UserEntity, 'avatar' | 'name' | 'sex' | 'online' | 'country_code' | 'home_country_code'>;

    // Show country flag in lower left corner, only if icon not specified
    withFlag?: boolean;

    // Show only indicator in top right corner, only if indicator color not specified
    withOnline?: boolean;

    size?: ThumbSize;
}

const UserAvatar: React.FC<UserAvatarProps> = ({
    user,
    size = 'L',
    withFlag = true,
    indicatorColor,
    withOnline = false,
    ...rest
}) => {
    // Deleted user
    if (!user) {
        return <Thumbnail src={DeletedUserAvatar} size={size} indicatorColor={indicatorColor} {...rest} />;
    }

    return (
        <Thumbnail
            size={size}
            photo={user.avatar}
            src={user.avatar ? undefined : user.sex === 'male' ? EmptyAvatarMale : EmptyAvatarFemale}
            countryFlagCode={withFlag ? user.home_country_code ?? user.country_code : undefined}
            indicatorColor={indicatorColor ?? (withOnline && user.online ? 'green' : undefined)}
            {...rest}
        />
    );
};

export default React.memo(UserAvatar);
